import Signal from "libs/signals";


const $businessApplication = Signal(null);
export default $businessApplication;